/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createAppUser = /* GraphQL */ `
  mutation CreateAppUser(
    $input: CreateAppUserInput!
    $condition: ModelAppUserConditionInput
  ) {
    createAppUser(input: $input, condition: $condition) {
      id
      profile
      username
      authUsername
      authUserID
      type
      icon
      isEnabled
      createdAt
      updatedAt
      groupID
      group {
        id
        groupName
        groupType
        icon
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      farms {
        nextToken
        startedAt
      }
      photos {
        nextToken
        startedAt
      }
      messages {
        nextToken
        startedAt
      }
      conversations {
        nextToken
        startedAt
      }
      sendPictures {
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateAppUser = /* GraphQL */ `
  mutation UpdateAppUser(
    $input: UpdateAppUserInput!
    $condition: ModelAppUserConditionInput
  ) {
    updateAppUser(input: $input, condition: $condition) {
      id
      profile
      username
      authUsername
      authUserID
      type
      icon
      isEnabled
      createdAt
      updatedAt
      groupID
      group {
        id
        groupName
        groupType
        icon
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      farms {
        nextToken
        startedAt
      }
      photos {
        nextToken
        startedAt
      }
      messages {
        nextToken
        startedAt
      }
      conversations {
        nextToken
        startedAt
      }
      sendPictures {
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteAppUser = /* GraphQL */ `
  mutation DeleteAppUser(
    $input: DeleteAppUserInput!
    $condition: ModelAppUserConditionInput
  ) {
    deleteAppUser(input: $input, condition: $condition) {
      id
      profile
      username
      authUsername
      authUserID
      type
      icon
      isEnabled
      createdAt
      updatedAt
      groupID
      group {
        id
        groupName
        groupType
        icon
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      farms {
        nextToken
        startedAt
      }
      photos {
        nextToken
        startedAt
      }
      messages {
        nextToken
        startedAt
      }
      conversations {
        nextToken
        startedAt
      }
      sendPictures {
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createUserGroup = /* GraphQL */ `
  mutation CreateUserGroup(
    $input: CreateUserGroupInput!
    $condition: ModelUserGroupConditionInput
  ) {
    createUserGroup(input: $input, condition: $condition) {
      id
      users {
        nextToken
        startedAt
      }
      groupName
      groupType
      icon
      createdAt
      updatedAt
      farms {
        nextToken
        startedAt
      }
      groupConversations {
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateUserGroup = /* GraphQL */ `
  mutation UpdateUserGroup(
    $input: UpdateUserGroupInput!
    $condition: ModelUserGroupConditionInput
  ) {
    updateUserGroup(input: $input, condition: $condition) {
      id
      users {
        nextToken
        startedAt
      }
      groupName
      groupType
      icon
      createdAt
      updatedAt
      farms {
        nextToken
        startedAt
      }
      groupConversations {
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteUserGroup = /* GraphQL */ `
  mutation DeleteUserGroup(
    $input: DeleteUserGroupInput!
    $condition: ModelUserGroupConditionInput
  ) {
    deleteUserGroup(input: $input, condition: $condition) {
      id
      users {
        nextToken
        startedAt
      }
      groupName
      groupType
      icon
      createdAt
      updatedAt
      farms {
        nextToken
        startedAt
      }
      groupConversations {
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createCooperation = /* GraphQL */ `
  mutation CreateCooperation(
    $input: CreateCooperationInput!
    $condition: ModelCooperationConditionInput
  ) {
    createCooperation(input: $input, condition: $condition) {
      groupID
      cooperationGroupID
      createdAt
      updatedAt
      id
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateCooperation = /* GraphQL */ `
  mutation UpdateCooperation(
    $input: UpdateCooperationInput!
    $condition: ModelCooperationConditionInput
  ) {
    updateCooperation(input: $input, condition: $condition) {
      groupID
      cooperationGroupID
      createdAt
      updatedAt
      id
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteCooperation = /* GraphQL */ `
  mutation DeleteCooperation(
    $input: DeleteCooperationInput!
    $condition: ModelCooperationConditionInput
  ) {
    deleteCooperation(input: $input, condition: $condition) {
      groupID
      cooperationGroupID
      createdAt
      updatedAt
      id
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createFriendship = /* GraphQL */ `
  mutation CreateFriendship(
    $input: CreateFriendshipInput!
    $condition: ModelFriendshipConditionInput
  ) {
    createFriendship(input: $input, condition: $condition) {
      userID
      friendID
      createdAt
      updatedAt
      id
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateFriendship = /* GraphQL */ `
  mutation UpdateFriendship(
    $input: UpdateFriendshipInput!
    $condition: ModelFriendshipConditionInput
  ) {
    updateFriendship(input: $input, condition: $condition) {
      userID
      friendID
      createdAt
      updatedAt
      id
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteFriendship = /* GraphQL */ `
  mutation DeleteFriendship(
    $input: DeleteFriendshipInput!
    $condition: ModelFriendshipConditionInput
  ) {
    deleteFriendship(input: $input, condition: $condition) {
      userID
      friendID
      createdAt
      updatedAt
      id
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createFarm = /* GraphQL */ `
  mutation CreateFarm(
    $input: CreateFarmInput!
    $condition: ModelFarmConditionInput
  ) {
    createFarm(input: $input, condition: $condition) {
      id
      userID
      user {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      groupID
      group {
        id
        groupName
        groupType
        icon
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      name
      lat
      lng
      memo
      createdAt
      updatedAt
      varieties
      photos {
        nextToken
        startedAt
      }
      dayDiagnoses {
        nextToken
        startedAt
      }
      dailyLogs {
        nextToken
        startedAt
      }
      monthReports {
        nextToken
        startedAt
      }
      cultivationEvents {
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateFarm = /* GraphQL */ `
  mutation UpdateFarm(
    $input: UpdateFarmInput!
    $condition: ModelFarmConditionInput
  ) {
    updateFarm(input: $input, condition: $condition) {
      id
      userID
      user {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      groupID
      group {
        id
        groupName
        groupType
        icon
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      name
      lat
      lng
      memo
      createdAt
      updatedAt
      varieties
      photos {
        nextToken
        startedAt
      }
      dayDiagnoses {
        nextToken
        startedAt
      }
      dailyLogs {
        nextToken
        startedAt
      }
      monthReports {
        nextToken
        startedAt
      }
      cultivationEvents {
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteFarm = /* GraphQL */ `
  mutation DeleteFarm(
    $input: DeleteFarmInput!
    $condition: ModelFarmConditionInput
  ) {
    deleteFarm(input: $input, condition: $condition) {
      id
      userID
      user {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      groupID
      group {
        id
        groupName
        groupType
        icon
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      name
      lat
      lng
      memo
      createdAt
      updatedAt
      varieties
      photos {
        nextToken
        startedAt
      }
      dayDiagnoses {
        nextToken
        startedAt
      }
      dailyLogs {
        nextToken
        startedAt
      }
      monthReports {
        nextToken
        startedAt
      }
      cultivationEvents {
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createPhoto = /* GraphQL */ `
  mutation CreatePhoto(
    $input: CreatePhotoInput!
    $condition: ModelPhotoConditionInput
  ) {
    createPhoto(input: $input, condition: $condition) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      userID
      user {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      photoKey
      takenAt
      lat
      lng
      depthsKey
      createdAt
      updatedAt
      diagnoses {
        nextToken
        startedAt
      }
      comments {
        nextToken
        startedAt
      }
      dayDiagnosisID
      dayDiagnosis {
        id
        farmID
        date
        isAggregated
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      diagnoseTypes
      distanceToPearShelf
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updatePhoto = /* GraphQL */ `
  mutation UpdatePhoto(
    $input: UpdatePhotoInput!
    $condition: ModelPhotoConditionInput
  ) {
    updatePhoto(input: $input, condition: $condition) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      userID
      user {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      photoKey
      takenAt
      lat
      lng
      depthsKey
      createdAt
      updatedAt
      diagnoses {
        nextToken
        startedAt
      }
      comments {
        nextToken
        startedAt
      }
      dayDiagnosisID
      dayDiagnosis {
        id
        farmID
        date
        isAggregated
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      diagnoseTypes
      distanceToPearShelf
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deletePhoto = /* GraphQL */ `
  mutation DeletePhoto(
    $input: DeletePhotoInput!
    $condition: ModelPhotoConditionInput
  ) {
    deletePhoto(input: $input, condition: $condition) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      userID
      user {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      photoKey
      takenAt
      lat
      lng
      depthsKey
      createdAt
      updatedAt
      diagnoses {
        nextToken
        startedAt
      }
      comments {
        nextToken
        startedAt
      }
      dayDiagnosisID
      dayDiagnosis {
        id
        farmID
        date
        isAggregated
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      diagnoseTypes
      distanceToPearShelf
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createDiagnosis = /* GraphQL */ `
  mutation CreateDiagnosis(
    $input: CreateDiagnosisInput!
    $condition: ModelDiagnosisConditionInput
  ) {
    createDiagnosis(input: $input, condition: $condition) {
      id
      photoID
      photo {
        id
        farmID
        userID
        photoKey
        takenAt
        lat
        lng
        depthsKey
        createdAt
        updatedAt
        dayDiagnosisID
        diagnoseTypes
        distanceToPearShelf
        _version
        _deleted
        _lastChangedAt
      }
      diagnoseType
      diagnoseResult
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateDiagnosis = /* GraphQL */ `
  mutation UpdateDiagnosis(
    $input: UpdateDiagnosisInput!
    $condition: ModelDiagnosisConditionInput
  ) {
    updateDiagnosis(input: $input, condition: $condition) {
      id
      photoID
      photo {
        id
        farmID
        userID
        photoKey
        takenAt
        lat
        lng
        depthsKey
        createdAt
        updatedAt
        dayDiagnosisID
        diagnoseTypes
        distanceToPearShelf
        _version
        _deleted
        _lastChangedAt
      }
      diagnoseType
      diagnoseResult
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteDiagnosis = /* GraphQL */ `
  mutation DeleteDiagnosis(
    $input: DeleteDiagnosisInput!
    $condition: ModelDiagnosisConditionInput
  ) {
    deleteDiagnosis(input: $input, condition: $condition) {
      id
      photoID
      photo {
        id
        farmID
        userID
        photoKey
        takenAt
        lat
        lng
        depthsKey
        createdAt
        updatedAt
        dayDiagnosisID
        diagnoseTypes
        distanceToPearShelf
        _version
        _deleted
        _lastChangedAt
      }
      diagnoseType
      diagnoseResult
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createDayDiagnosis = /* GraphQL */ `
  mutation CreateDayDiagnosis(
    $input: CreateDayDiagnosisInput!
    $condition: ModelDayDiagnosisConditionInput
  ) {
    createDayDiagnosis(input: $input, condition: $condition) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      date
      isAggregated
      photos {
        nextToken
        startedAt
      }
      comments {
        nextToken
        startedAt
      }
      diagnosisSummaries {
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateDayDiagnosis = /* GraphQL */ `
  mutation UpdateDayDiagnosis(
    $input: UpdateDayDiagnosisInput!
    $condition: ModelDayDiagnosisConditionInput
  ) {
    updateDayDiagnosis(input: $input, condition: $condition) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      date
      isAggregated
      photos {
        nextToken
        startedAt
      }
      comments {
        nextToken
        startedAt
      }
      diagnosisSummaries {
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteDayDiagnosis = /* GraphQL */ `
  mutation DeleteDayDiagnosis(
    $input: DeleteDayDiagnosisInput!
    $condition: ModelDayDiagnosisConditionInput
  ) {
    deleteDayDiagnosis(input: $input, condition: $condition) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      date
      isAggregated
      photos {
        nextToken
        startedAt
      }
      comments {
        nextToken
        startedAt
      }
      diagnosisSummaries {
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createDiagnosisSummary = /* GraphQL */ `
  mutation CreateDiagnosisSummary(
    $input: CreateDiagnosisSummaryInput!
    $condition: ModelDiagnosisSummaryConditionInput
  ) {
    createDiagnosisSummary(input: $input, condition: $condition) {
      id
      dayDiagnosisID
      dayDiagnosis {
        id
        farmID
        date
        isAggregated
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      diagnoseType
      diagnoseResult
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateDiagnosisSummary = /* GraphQL */ `
  mutation UpdateDiagnosisSummary(
    $input: UpdateDiagnosisSummaryInput!
    $condition: ModelDiagnosisSummaryConditionInput
  ) {
    updateDiagnosisSummary(input: $input, condition: $condition) {
      id
      dayDiagnosisID
      dayDiagnosis {
        id
        farmID
        date
        isAggregated
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      diagnoseType
      diagnoseResult
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteDiagnosisSummary = /* GraphQL */ `
  mutation DeleteDiagnosisSummary(
    $input: DeleteDiagnosisSummaryInput!
    $condition: ModelDiagnosisSummaryConditionInput
  ) {
    deleteDiagnosisSummary(input: $input, condition: $condition) {
      id
      dayDiagnosisID
      dayDiagnosis {
        id
        farmID
        date
        isAggregated
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      diagnoseType
      diagnoseResult
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createPhotoComment = /* GraphQL */ `
  mutation CreatePhotoComment(
    $input: CreatePhotoCommentInput!
    $condition: ModelPhotoCommentConditionInput
  ) {
    createPhotoComment(input: $input, condition: $condition) {
      id
      photoID
      photo {
        id
        farmID
        userID
        photoKey
        takenAt
        lat
        lng
        depthsKey
        createdAt
        updatedAt
        dayDiagnosisID
        diagnoseTypes
        distanceToPearShelf
        _version
        _deleted
        _lastChangedAt
      }
      authorID
      text
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updatePhotoComment = /* GraphQL */ `
  mutation UpdatePhotoComment(
    $input: UpdatePhotoCommentInput!
    $condition: ModelPhotoCommentConditionInput
  ) {
    updatePhotoComment(input: $input, condition: $condition) {
      id
      photoID
      photo {
        id
        farmID
        userID
        photoKey
        takenAt
        lat
        lng
        depthsKey
        createdAt
        updatedAt
        dayDiagnosisID
        diagnoseTypes
        distanceToPearShelf
        _version
        _deleted
        _lastChangedAt
      }
      authorID
      text
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deletePhotoComment = /* GraphQL */ `
  mutation DeletePhotoComment(
    $input: DeletePhotoCommentInput!
    $condition: ModelPhotoCommentConditionInput
  ) {
    deletePhotoComment(input: $input, condition: $condition) {
      id
      photoID
      photo {
        id
        farmID
        userID
        photoKey
        takenAt
        lat
        lng
        depthsKey
        createdAt
        updatedAt
        dayDiagnosisID
        diagnoseTypes
        distanceToPearShelf
        _version
        _deleted
        _lastChangedAt
      }
      authorID
      text
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createDayDiagnoseComment = /* GraphQL */ `
  mutation CreateDayDiagnoseComment(
    $input: CreateDayDiagnoseCommentInput!
    $condition: ModelDayDiagnoseCommentConditionInput
  ) {
    createDayDiagnoseComment(input: $input, condition: $condition) {
      id
      dayDiagnosisID
      dayDiagnosis {
        id
        farmID
        date
        isAggregated
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      authorID
      text
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateDayDiagnoseComment = /* GraphQL */ `
  mutation UpdateDayDiagnoseComment(
    $input: UpdateDayDiagnoseCommentInput!
    $condition: ModelDayDiagnoseCommentConditionInput
  ) {
    updateDayDiagnoseComment(input: $input, condition: $condition) {
      id
      dayDiagnosisID
      dayDiagnosis {
        id
        farmID
        date
        isAggregated
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      authorID
      text
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteDayDiagnoseComment = /* GraphQL */ `
  mutation DeleteDayDiagnoseComment(
    $input: DeleteDayDiagnoseCommentInput!
    $condition: ModelDayDiagnoseCommentConditionInput
  ) {
    deleteDayDiagnoseComment(input: $input, condition: $condition) {
      id
      dayDiagnosisID
      dayDiagnosis {
        id
        farmID
        date
        isAggregated
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      authorID
      text
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createDailyLog = /* GraphQL */ `
  mutation CreateDailyLog(
    $input: CreateDailyLogInput!
    $condition: ModelDailyLogConditionInput
  ) {
    createDailyLog(input: $input, condition: $condition) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      monthReportID
      monthReport {
        id
        farmID
        yearMonth
        totalWorkingTime
        pesticideSprayningTime
        matingWorkTime
        harvestingTime
        fruitsThinningTime
        othersTime
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      category
      categoryOptional
      date
      workingTime
      workMemo
      varieties
      authorID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateDailyLog = /* GraphQL */ `
  mutation UpdateDailyLog(
    $input: UpdateDailyLogInput!
    $condition: ModelDailyLogConditionInput
  ) {
    updateDailyLog(input: $input, condition: $condition) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      monthReportID
      monthReport {
        id
        farmID
        yearMonth
        totalWorkingTime
        pesticideSprayningTime
        matingWorkTime
        harvestingTime
        fruitsThinningTime
        othersTime
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      category
      categoryOptional
      date
      workingTime
      workMemo
      varieties
      authorID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteDailyLog = /* GraphQL */ `
  mutation DeleteDailyLog(
    $input: DeleteDailyLogInput!
    $condition: ModelDailyLogConditionInput
  ) {
    deleteDailyLog(input: $input, condition: $condition) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      monthReportID
      monthReport {
        id
        farmID
        yearMonth
        totalWorkingTime
        pesticideSprayningTime
        matingWorkTime
        harvestingTime
        fruitsThinningTime
        othersTime
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      category
      categoryOptional
      date
      workingTime
      workMemo
      varieties
      authorID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createCultivationEvent = /* GraphQL */ `
  mutation CreateCultivationEvent(
    $input: CreateCultivationEventInput!
    $condition: ModelCultivationEventConditionInput
  ) {
    createCultivationEvent(input: $input, condition: $condition) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      eventCategory
      eventCategoryOptional
      startDate
      finishDate
      memo
      createdAt
      updatedAt
      authorID
      varieties
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateCultivationEvent = /* GraphQL */ `
  mutation UpdateCultivationEvent(
    $input: UpdateCultivationEventInput!
    $condition: ModelCultivationEventConditionInput
  ) {
    updateCultivationEvent(input: $input, condition: $condition) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      eventCategory
      eventCategoryOptional
      startDate
      finishDate
      memo
      createdAt
      updatedAt
      authorID
      varieties
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteCultivationEvent = /* GraphQL */ `
  mutation DeleteCultivationEvent(
    $input: DeleteCultivationEventInput!
    $condition: ModelCultivationEventConditionInput
  ) {
    deleteCultivationEvent(input: $input, condition: $condition) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      eventCategory
      eventCategoryOptional
      startDate
      finishDate
      memo
      createdAt
      updatedAt
      authorID
      varieties
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createMonthReport = /* GraphQL */ `
  mutation CreateMonthReport(
    $input: CreateMonthReportInput!
    $condition: ModelMonthReportConditionInput
  ) {
    createMonthReport(input: $input, condition: $condition) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      yearMonth
      totalWorkingTime
      pesticideSprayningTime
      matingWorkTime
      harvestingTime
      fruitsThinningTime
      othersTime
      createdAt
      updatedAt
      dailyLogs {
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateMonthReport = /* GraphQL */ `
  mutation UpdateMonthReport(
    $input: UpdateMonthReportInput!
    $condition: ModelMonthReportConditionInput
  ) {
    updateMonthReport(input: $input, condition: $condition) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      yearMonth
      totalWorkingTime
      pesticideSprayningTime
      matingWorkTime
      harvestingTime
      fruitsThinningTime
      othersTime
      createdAt
      updatedAt
      dailyLogs {
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteMonthReport = /* GraphQL */ `
  mutation DeleteMonthReport(
    $input: DeleteMonthReportInput!
    $condition: ModelMonthReportConditionInput
  ) {
    deleteMonthReport(input: $input, condition: $condition) {
      id
      farmID
      farm {
        id
        userID
        groupID
        name
        lat
        lng
        memo
        createdAt
        updatedAt
        varieties
        _version
        _deleted
        _lastChangedAt
      }
      yearMonth
      totalWorkingTime
      pesticideSprayningTime
      matingWorkTime
      harvestingTime
      fruitsThinningTime
      othersTime
      createdAt
      updatedAt
      dailyLogs {
        nextToken
        startedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createMessage = /* GraphQL */ `
  mutation CreateMessage(
    $input: CreateMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    createMessage(input: $input, condition: $condition) {
      id
      conversationID
      conversation {
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      senderID
      sender {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      content
      createdAt
      updatedAt
      isSent
      isRead
      isImportant
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateMessage = /* GraphQL */ `
  mutation UpdateMessage(
    $input: UpdateMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    updateMessage(input: $input, condition: $condition) {
      id
      conversationID
      conversation {
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      senderID
      sender {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      content
      createdAt
      updatedAt
      isSent
      isRead
      isImportant
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteMessage = /* GraphQL */ `
  mutation DeleteMessage(
    $input: DeleteMessageInput!
    $condition: ModelMessageConditionInput
  ) {
    deleteMessage(input: $input, condition: $condition) {
      id
      conversationID
      conversation {
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      senderID
      sender {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      content
      createdAt
      updatedAt
      isSent
      isRead
      isImportant
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createConversation = /* GraphQL */ `
  mutation CreateConversation(
    $input: CreateConversationInput!
    $condition: ModelConversationConditionInput
  ) {
    createConversation(input: $input, condition: $condition) {
      id
      users {
        nextToken
        startedAt
      }
      groups {
        nextToken
        startedAt
      }
      messages {
        nextToken
        startedAt
      }
      sendPictures {
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateConversation = /* GraphQL */ `
  mutation UpdateConversation(
    $input: UpdateConversationInput!
    $condition: ModelConversationConditionInput
  ) {
    updateConversation(input: $input, condition: $condition) {
      id
      users {
        nextToken
        startedAt
      }
      groups {
        nextToken
        startedAt
      }
      messages {
        nextToken
        startedAt
      }
      sendPictures {
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteConversation = /* GraphQL */ `
  mutation DeleteConversation(
    $input: DeleteConversationInput!
    $condition: ModelConversationConditionInput
  ) {
    deleteConversation(input: $input, condition: $condition) {
      id
      users {
        nextToken
        startedAt
      }
      groups {
        nextToken
        startedAt
      }
      messages {
        nextToken
        startedAt
      }
      sendPictures {
        nextToken
        startedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createUserConversation = /* GraphQL */ `
  mutation CreateUserConversation(
    $input: CreateUserConversationInput!
    $condition: ModelUserConversationConditionInput
  ) {
    createUserConversation(input: $input, condition: $condition) {
      id
      userID
      user {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      conversationID
      createdAt
      updatedAt
      conversation {
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateUserConversation = /* GraphQL */ `
  mutation UpdateUserConversation(
    $input: UpdateUserConversationInput!
    $condition: ModelUserConversationConditionInput
  ) {
    updateUserConversation(input: $input, condition: $condition) {
      id
      userID
      user {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      conversationID
      createdAt
      updatedAt
      conversation {
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteUserConversation = /* GraphQL */ `
  mutation DeleteUserConversation(
    $input: DeleteUserConversationInput!
    $condition: ModelUserConversationConditionInput
  ) {
    deleteUserConversation(input: $input, condition: $condition) {
      id
      userID
      user {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      conversationID
      createdAt
      updatedAt
      conversation {
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createGroupConversation = /* GraphQL */ `
  mutation CreateGroupConversation(
    $input: CreateGroupConversationInput!
    $condition: ModelGroupConversationConditionInput
  ) {
    createGroupConversation(input: $input, condition: $condition) {
      id
      groupID
      group {
        id
        groupName
        groupType
        icon
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      conversationID
      createdAt
      updatedAt
      conversation {
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      isIntergroup
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateGroupConversation = /* GraphQL */ `
  mutation UpdateGroupConversation(
    $input: UpdateGroupConversationInput!
    $condition: ModelGroupConversationConditionInput
  ) {
    updateGroupConversation(input: $input, condition: $condition) {
      id
      groupID
      group {
        id
        groupName
        groupType
        icon
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      conversationID
      createdAt
      updatedAt
      conversation {
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      isIntergroup
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteGroupConversation = /* GraphQL */ `
  mutation DeleteGroupConversation(
    $input: DeleteGroupConversationInput!
    $condition: ModelGroupConversationConditionInput
  ) {
    deleteGroupConversation(input: $input, condition: $condition) {
      id
      groupID
      group {
        id
        groupName
        groupType
        icon
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      conversationID
      createdAt
      updatedAt
      conversation {
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      isIntergroup
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createSendPicture = /* GraphQL */ `
  mutation CreateSendPicture(
    $input: CreateSendPictureInput!
    $condition: ModelSendPictureConditionInput
  ) {
    createSendPicture(input: $input, condition: $condition) {
      id
      conversationID
      conversation {
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      senderID
      sender {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      sendPhotokey
      createdAt
      updatedAt
      isSent
      isRead
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateSendPicture = /* GraphQL */ `
  mutation UpdateSendPicture(
    $input: UpdateSendPictureInput!
    $condition: ModelSendPictureConditionInput
  ) {
    updateSendPicture(input: $input, condition: $condition) {
      id
      conversationID
      conversation {
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      senderID
      sender {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      sendPhotokey
      createdAt
      updatedAt
      isSent
      isRead
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteSendPicture = /* GraphQL */ `
  mutation DeleteSendPicture(
    $input: DeleteSendPictureInput!
    $condition: ModelSendPictureConditionInput
  ) {
    deleteSendPicture(input: $input, condition: $condition) {
      id
      conversationID
      conversation {
        id
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      senderID
      sender {
        id
        profile
        username
        authUsername
        authUserID
        type
        icon
        isEnabled
        createdAt
        updatedAt
        groupID
        _version
        _deleted
        _lastChangedAt
      }
      sendPhotokey
      createdAt
      updatedAt
      isSent
      isRead
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
